import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';


const local_language = localStorage.getItem('lang')

const UpdateServiceManagementvalidation: any = yup.object().shape({

    name: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("emri i shërbimit") : ValidationMessage.Field("service name")).min(3, local_language == "alb" ? ValidationMessageAlbanian.MinLength('emri i shërbimit', 3) : ValidationMessage?.MinLength("service name", 3)),
    price: yup
        .string()
        .required(local_language == "alb" ? ValidationMessageAlbanian.Field("çmimi i shërbimit") : ValidationMessage.Field("service price"))
        .min(2, local_language == "alb" ? "Çmimi i shërbimit duhet të jetë të paktën 3 shifror" : "Service price must be at least 2 digits.")
        .matches(/^[1-9][0-9]{0,4}$/, 'Ju lutemi vendosni një çmim të vlefshëm me deri në 5 shifra')
        .test('min-value', 'Vlera minimale duhet të jetë së paku 2 shifrore.', value => parseInt(value, 10) >= 2),


    duration: yup.string().required('Ju lutemi zgjidhni kohëzgjatjen e shërbimit'), // Example validation rule
    category: yup.string().required(local_language == "alb" ? 'Ju lutemi zgjidhni të paktën një kategori.':"Please select at least one category."),


    description: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("përshkrimi i shërbimit") : ValidationMessage.Field("service description"))
        .max(300, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('përshkrim', 300) : ValidationMessage.MaxLength('description', 300)),

});




export default UpdateServiceManagementvalidation;
